var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 8.84641C26.9587 12.2002 28.825 16.3152 30.225 17.9502C30.5 17.3152 30.47 16.2502 30.7825 13.6502C31.065 11.3052 33 11.0814 33.8312 11.2477C35.6687 11.6314 36.2275 13.4927 36.1662 14.1789C36.0687 15.2727 36.0637 15.2352 35.8637 17.8814C35.57 21.7502 37.0637 24.6714 37.2012 27.9839C37.2012 34.2264 31.73 37.2939 27.9012 37.2939C24.8375 37.2939 21.7712 35.3339 20.6225 34.3539L14.8775 29.1064C14.1737 28.5602 12.4362 26.7552 11.6737 25.7164C9.59371 22.8877 12.6012 20.9389 14.2912 21.4289C14.1587 21.3264 13.3562 20.0239 12.9725 19.3864C11.9412 17.3152 12.9725 15.9364 13.735 15.5564C15.4637 14.6964 16.735 15.6639 17.135 16.1914C16.9812 15.9314 16.5012 14.8789 15.7275 12.9477C14.9537 11.0177 16.2 9.82516 16.92 9.47016C18.4825 8.74641 19.9675 9.66516 20.3387 10.4864C20.5212 10.8877 21.5012 13.0364 21.9287 13.9827C21.6062 13.1977 21.0237 11.6364 20.8175 10.9152C20.4075 9.21516 21.3937 8.05016 22.02 7.75016C22.8887 7.33391 24.7025 7.22516 25.42 8.80516L25.4375 8.84641Z",
    fill: "url(#paint0_radial_1107_345)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 8.84641C26.9588 12.2002 28.825 16.3152 30.225 17.9502C30.5 17.3152 30.47 16.2502 30.7825 13.6502C31.065 11.3052 33 11.0814 33.8313 11.2477C35.6688 11.6314 36.2275 13.4927 36.1663 14.1789C36.0688 15.2727 36.0638 15.2352 35.8638 17.8814C35.57 21.7502 37.0638 24.6714 37.2013 27.9839C37.2013 34.2264 31.73 37.2939 27.9013 37.2939C24.8375 37.2939 21.7713 35.3339 20.6225 34.3539L14.8775 29.1064C14.1738 28.5602 12.4363 26.7552 11.6725 25.7164C9.59377 22.8877 12.6013 20.9389 14.2913 21.4289C14.1588 21.3264 13.3563 20.0239 12.9725 19.3864C11.9413 17.3152 12.9725 15.9364 13.735 15.5564C15.4638 14.6964 16.735 15.6639 17.135 16.1914C16.9813 15.9314 16.5013 14.8789 15.7275 12.9477C14.9538 11.0177 16.2 9.82516 16.92 9.47016C18.4825 8.74641 19.9675 9.66516 20.3388 10.4864C20.5213 10.8877 21.5013 13.0364 21.9288 13.9827C21.6063 13.1977 21.0238 11.6364 20.8175 10.9152C20.4075 9.21516 21.3938 8.05016 22.0188 7.75016C22.8888 7.33391 24.7025 7.22516 25.4188 8.80516L25.4375 8.84641Z",
    fill: "url(#paint1_radial_1107_345)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1662 14.1787C36.0687 15.2724 36.0637 15.2349 35.8637 17.8812C35.7599 19.2487 36.5024 24.2824 36.5024 24.2824C34.6962 24.8724 30.7824 24.0912 30.2262 17.9499C30.4999 17.3149 30.4699 16.2499 30.7824 13.6499C31.0649 11.3037 32.9999 11.0812 33.8312 11.2474C35.6687 11.6312 36.2274 13.4924 36.1662 14.1787Z",
    fill: "url(#paint2_radial_1107_345)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1662 14.1787C36.0687 15.2724 36.0637 15.2349 35.8637 17.8812C35.7599 19.2487 36.5024 24.2824 36.5024 24.2824C34.6962 24.8724 30.7824 24.0912 30.2262 17.9499C30.4999 17.3149 30.4699 16.2499 30.7824 13.6499C31.0649 11.3037 32.9999 11.0812 33.8312 11.2474C35.6687 11.6312 36.2274 13.4924 36.1662 14.1787Z",
    fill: "url(#paint3_radial_1107_345)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1662 14.1787C36.0687 15.2724 36.0637 15.2349 35.8637 17.8812C35.7599 19.2487 36.5024 24.2824 36.5024 24.2824C34.6962 24.8724 30.7824 24.0912 30.2262 17.9499C30.4999 17.3149 30.4699 16.2499 30.7824 13.6499C31.0649 11.3037 32.9999 11.0812 33.8312 11.2474C35.6687 11.6312 36.2274 13.4924 36.1662 14.1787Z",
    fill: "url(#paint4_radial_1107_345)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 8.84641C26.9588 12.2002 28.825 16.3152 30.225 17.9502C30.0063 19.8202 28.335 20.7152 26.895 20.3802C25.0788 19.8527 24.3888 18.5639 24.3888 18.5639C24.3888 18.5639 23.9138 17.8289 23.4513 17.0202C22.9163 16.0852 23.0138 16.1064 22.1175 14.4139C21.9413 14.0814 21.0788 11.8264 20.8175 10.9152C20.4075 9.21516 21.3938 8.05016 22.02 7.75016C22.8888 7.33391 24.7025 7.22516 25.42 8.80516L25.4375 8.84641Z",
    fill: "url(#paint5_radial_1107_345)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 8.84641C26.9588 12.2002 28.825 16.3152 30.225 17.9502C30.0063 19.8202 28.335 20.7152 26.895 20.3802C25.0788 19.8527 24.3888 18.5639 24.3888 18.5639C24.3888 18.5639 23.9138 17.8289 23.4513 17.0202C22.9163 16.0852 23.0138 16.1064 22.1175 14.4139C21.9413 14.0814 21.0788 11.8264 20.8175 10.9152C20.4075 9.21516 21.3938 8.05016 22.02 7.75016C22.8888 7.33391 24.7025 7.22516 25.42 8.80516L25.4375 8.84641Z",
    fill: "url(#paint6_linear_1107_345)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 8.84641C26.9588 12.2002 28.825 16.3152 30.225 17.9502C30.0063 19.8202 28.335 20.7152 26.895 20.3802C25.0788 19.8527 24.3888 18.5639 24.3888 18.5639C24.3888 18.5639 23.9138 17.8289 23.4513 17.0202C22.9163 16.0852 23.0138 16.1064 22.1175 14.4139C21.9413 14.0814 21.0788 11.8264 20.8175 10.9152C20.4075 9.21516 21.3938 8.05016 22.02 7.75016C22.8888 7.33391 24.7025 7.22516 25.42 8.80516L25.4375 8.84641Z",
    fill: "url(#paint7_radial_1107_345)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 8.84641C26.9588 12.2002 28.825 16.3152 30.225 17.9502C30.0063 19.8202 28.335 20.7152 26.895 20.3802C25.0788 19.8527 24.3888 18.5639 24.3888 18.5639C24.3888 18.5639 23.9138 17.8289 23.4513 17.0202C22.9163 16.0852 23.0138 16.1064 22.1175 14.4139C21.9413 14.0814 21.0788 11.8264 20.8175 10.9152C20.4075 9.21516 21.3938 8.05016 22.02 7.75016C22.8888 7.33391 24.7025 7.22516 25.42 8.80516L25.4375 8.84641Z",
    fill: "url(#paint8_radial_1107_345)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 8.84641C26.9588 12.2002 28.825 16.3152 30.225 17.9502C30.0063 19.8202 28.335 20.7152 26.895 20.3802C25.0788 19.8527 24.3888 18.5639 24.3888 18.5639C24.3888 18.5639 23.9138 17.8289 23.4513 17.0202C22.9163 16.0852 23.0138 16.1064 22.1175 14.4139C21.9413 14.0814 21.0788 11.8264 20.8175 10.9152C20.4075 9.21516 21.3938 8.05016 22.02 7.75016C22.8888 7.33391 24.7025 7.22516 25.42 8.80516L25.4375 8.84641Z",
    fill: "url(#paint9_linear_1107_345)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3387 10.4864C20.5837 11.0264 22.2737 14.7264 22.1174 14.4139C22.5712 15.4389 23.9799 17.9389 24.3887 18.6226C25.2937 20.1301 24.2724 21.3839 23.6137 21.7664C21.7174 22.8664 20.6287 21.4639 20.6287 21.4639C19.6287 19.9989 18.7937 18.7789 17.1424 16.1814C16.7449 15.4314 16.0199 13.7589 15.7274 12.9476C15.0062 10.9451 16.1999 9.82512 16.9199 9.47012C18.4824 8.74637 19.9674 9.66512 20.3387 10.4864Z",
    fill: "url(#paint10_radial_1107_345)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3387 10.4864C20.5837 11.0264 22.2737 14.7264 22.1174 14.4139C22.5712 15.4389 23.9799 17.9389 24.3887 18.6226C25.2937 20.1301 24.2724 21.3839 23.6137 21.7664C21.7174 22.8664 20.6287 21.4639 20.6287 21.4639C19.6287 19.9989 18.7937 18.7789 17.1424 16.1814C16.7449 15.4314 16.0199 13.7589 15.7274 12.9476C15.0062 10.9451 16.1999 9.82512 16.9199 9.47012C18.4824 8.74637 19.9674 9.66512 20.3387 10.4864Z",
    fill: "url(#paint11_linear_1107_345)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3387 10.4864C20.5837 11.0264 22.2737 14.7264 22.1174 14.4139C22.5712 15.4389 23.9799 17.9389 24.3887 18.6226C25.2937 20.1301 24.2724 21.3839 23.6137 21.7664C21.7174 22.8664 20.6287 21.4639 20.6287 21.4639C19.6287 19.9989 18.7937 18.7789 17.1424 16.1814C16.7449 15.4314 16.0199 13.7589 15.7274 12.9476C15.0062 10.9451 16.1999 9.82512 16.9199 9.47012C18.4824 8.74637 19.9674 9.66512 20.3387 10.4864Z",
    fill: "url(#paint12_radial_1107_345)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3387 10.4864C20.5837 11.0264 22.2737 14.7264 22.1174 14.4139C22.5712 15.4389 23.9799 17.9389 24.3887 18.6226C25.2937 20.1301 24.2724 21.3839 23.6137 21.7664C21.7174 22.8664 20.6287 21.4639 20.6287 21.4639C19.6287 19.9989 18.7937 18.7789 17.1424 16.1814C16.7449 15.4314 16.0199 13.7589 15.7274 12.9476C15.0062 10.9451 16.1999 9.82512 16.9199 9.47012C18.4824 8.74637 19.9674 9.66512 20.3387 10.4864Z",
    fill: "url(#paint13_radial_1107_345)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3387 10.4864C20.5837 11.0264 22.2737 14.7264 22.1174 14.4139C22.5712 15.4389 23.9799 17.9389 24.3887 18.6226C25.2937 20.1301 24.2724 21.3839 23.6137 21.7664C21.7174 22.8664 20.6287 21.4639 20.6287 21.4639C19.6287 19.9989 18.7937 18.7789 17.1424 16.1814C16.7449 15.4314 16.0199 13.7589 15.7274 12.9476C15.0062 10.9451 16.1999 9.82512 16.9199 9.47012C18.4824 8.74637 19.9674 9.66512 20.3387 10.4864Z",
    fill: "url(#paint14_radial_1107_345)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3387 10.4864C20.5837 11.0264 22.2737 14.7264 22.1174 14.4139C22.5712 15.4389 23.9799 17.9389 24.3887 18.6226C25.2937 20.1301 24.2724 21.3839 23.6137 21.7664C21.7174 22.8664 20.6287 21.4639 20.6287 21.4639C19.6287 19.9989 18.7937 18.7789 17.1424 16.1814C16.7449 15.4314 16.0199 13.7589 15.7274 12.9476C15.0062 10.9451 16.1999 9.82512 16.9199 9.47012C18.4824 8.74637 19.9674 9.66512 20.3387 10.4864Z",
    fill: "url(#paint15_linear_1107_345)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.735 15.5563C15.4638 14.6963 16.735 15.6638 17.135 16.1913C18.3825 18.0751 19.8725 20.2163 20.56 21.3563C22.3975 24.3938 18.6375 25.7113 18.6375 25.7113C15.18 21.8151 14.54 21.6188 14.2913 21.4276C14.1588 21.3263 13.3563 20.0238 12.9725 19.3863C11.9413 17.3151 12.9725 15.9351 13.735 15.5563Z",
    fill: "url(#paint16_radial_1107_345)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.735 15.5563C15.4638 14.6963 16.735 15.6638 17.135 16.1913C18.3825 18.0751 19.8725 20.2163 20.56 21.3563C22.3975 24.3938 18.6375 25.7113 18.6375 25.7113C15.18 21.8151 14.54 21.6188 14.2913 21.4276C14.1588 21.3263 13.3563 20.0238 12.9725 19.3863C11.9413 17.3151 12.9725 15.9351 13.735 15.5563Z",
    fill: "url(#paint17_linear_1107_345)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.735 15.5563C15.4638 14.6963 16.735 15.6638 17.135 16.1913C18.3825 18.0751 19.8725 20.2163 20.56 21.3563C22.3975 24.3938 18.6375 25.7113 18.6375 25.7113C15.18 21.8151 14.54 21.6188 14.2913 21.4276C14.1588 21.3263 13.3563 20.0238 12.9725 19.3863C11.9413 17.3151 12.9725 15.9351 13.735 15.5563Z",
    fill: "url(#paint18_radial_1107_345)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.735 15.5563C15.4638 14.6963 16.735 15.6638 17.135 16.1913C18.3825 18.0751 19.8725 20.2163 20.56 21.3563C22.3975 24.3938 18.6375 25.7113 18.6375 25.7113C15.18 21.8151 14.54 21.6188 14.2913 21.4276C14.1588 21.3263 13.3563 20.0238 12.9725 19.3863C11.9413 17.3151 12.9725 15.9351 13.735 15.5563Z",
    fill: "url(#paint19_radial_1107_345)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.735 15.5563C15.4638 14.6963 16.735 15.6638 17.135 16.1913C18.3825 18.0751 19.8725 20.2163 20.56 21.3563C22.3975 24.3938 18.6375 25.7113 18.6375 25.7113C15.18 21.8151 14.54 21.6188 14.2913 21.4276C14.1588 21.3263 13.3563 20.0238 12.9725 19.3863C11.9413 17.3151 12.9725 15.9351 13.735 15.5563Z",
    fill: "url(#paint20_radial_1107_345)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.735 15.5563C15.4638 14.6963 16.735 15.6638 17.135 16.1913C18.3825 18.0751 19.8725 20.2163 20.56 21.3563C22.3975 24.3938 18.6375 25.7113 18.6375 25.7113C15.18 21.8151 14.54 21.6188 14.2913 21.4276C14.1588 21.3263 13.3563 20.0238 12.9725 19.3863C11.9413 17.3151 12.9725 15.9351 13.735 15.5563Z",
    fill: "url(#paint21_radial_1107_345)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6725 25.7163C9.59377 22.8875 12.6013 20.9388 14.2913 21.4288C15.0913 21.9225 16.3288 23.1613 16.855 23.72C20.2075 26.9888 19.6488 27.9975 18.7113 29.1075C17.8025 29.86 16.6213 30.4638 14.8775 29.1075C14.1738 28.56 12.4363 26.755 11.6725 25.7163Z",
    fill: "url(#paint22_radial_1107_345)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6725 25.7163C9.59377 22.8875 12.6013 20.9388 14.2913 21.4288C15.0913 21.9225 16.3288 23.1613 16.855 23.72C20.2075 26.9888 19.6488 27.9975 18.7113 29.1075C17.8025 29.86 16.6213 30.4638 14.8775 29.1075C14.1738 28.56 12.4363 26.755 11.6725 25.7163Z",
    fill: "url(#paint23_radial_1107_345)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6725 25.7163C9.59377 22.8875 12.6013 20.9388 14.2913 21.4288C15.0913 21.9225 16.3288 23.1613 16.855 23.72C20.2075 26.9888 19.6488 27.9975 18.7113 29.1075C17.8025 29.86 16.6213 30.4638 14.8775 29.1075C14.1738 28.56 12.4363 26.755 11.6725 25.7163Z",
    fill: "url(#paint24_radial_1107_345)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6725 25.7163C9.59377 22.8875 12.6013 20.9388 14.2913 21.4288C15.0913 21.9225 16.3288 23.1613 16.855 23.72C20.2075 26.9888 19.6488 27.9975 18.7113 29.1075C17.8025 29.86 16.6213 30.4638 14.8775 29.1075C14.1738 28.56 12.4363 26.755 11.6725 25.7163Z",
    fill: "url(#paint25_radial_1107_345)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6725 25.7163C9.59377 22.8875 12.6013 20.9388 14.2913 21.4288C15.0913 21.9225 16.3288 23.1613 16.855 23.72C20.2075 26.9888 19.6488 27.9975 18.7113 29.1075C17.8025 29.86 16.6213 30.4638 14.8775 29.1075C14.1738 28.56 12.4363 26.755 11.6725 25.7163Z",
    fill: "url(#paint26_linear_1107_345)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 8.84641C26.9588 12.2002 28.825 16.3152 30.225 17.9502C30.5 17.3152 30.47 16.2502 30.7825 13.6502C31.065 11.3052 33 11.0814 33.8313 11.2477C35.6688 11.6314 36.2275 13.4927 36.1663 14.1789C36.0688 15.2727 36.0638 15.2352 35.8638 17.8814C35.57 21.7502 37.0638 24.6714 37.2013 27.9839C37.2013 34.2264 31.73 37.2939 27.9013 37.2939C24.8375 37.2939 21.7713 35.3339 20.6225 34.3539L14.8775 29.1064C14.1738 28.5602 12.4363 26.7552 11.6725 25.7164C9.59377 22.8877 12.6013 20.9389 14.2913 21.4289C14.1588 21.3264 13.3563 20.0239 12.9725 19.3864C11.9413 17.3152 12.9725 15.9364 13.735 15.5564C15.4638 14.6964 16.735 15.6639 17.135 16.1914C16.9813 15.9314 16.5013 14.8789 15.7275 12.9477C14.9538 11.0177 16.2 9.82516 16.92 9.47016C18.4825 8.74641 19.9675 9.66516 20.3388 10.4864C20.5213 10.8877 21.5013 13.0364 21.9288 13.9827C21.6063 13.1977 21.0238 11.6364 20.8175 10.9152C20.4075 9.21516 21.3938 8.05016 22.0188 7.75016C22.8888 7.33391 24.7025 7.22516 25.4188 8.80516L25.4375 8.84641Z",
    fill: "url(#paint27_radial_1107_345)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 8.84641C26.9588 12.2002 28.825 16.3152 30.225 17.9502C30.5 17.3152 30.47 16.2502 30.7825 13.6502C31.065 11.3052 33 11.0814 33.8313 11.2477C35.6688 11.6314 36.2275 13.4927 36.1663 14.1789C36.0688 15.2727 36.0638 15.2352 35.8638 17.8814C35.57 21.7502 37.0638 24.6714 37.2013 27.9839C37.2013 34.2264 31.73 37.2939 27.9013 37.2939C24.8375 37.2939 21.7713 35.3339 20.6225 34.3539L14.8775 29.1064C14.1738 28.5602 12.4363 26.7552 11.6725 25.7164C9.59377 22.8877 12.6013 20.9389 14.2913 21.4289C14.1588 21.3264 13.3563 20.0239 12.9725 19.3864C11.9413 17.3152 12.9725 15.9364 13.735 15.5564C15.4638 14.6964 16.735 15.6639 17.135 16.1914C16.9813 15.9314 16.5013 14.8789 15.7275 12.9477C14.9538 11.0177 16.2 9.82516 16.92 9.47016C18.4825 8.74641 19.9675 9.66516 20.3388 10.4864C20.5213 10.8877 21.5013 13.0364 21.9288 13.9827C21.6063 13.1977 21.0238 11.6364 20.8175 10.9152C20.4075 9.21516 21.3938 8.05016 22.0188 7.75016C22.8888 7.33391 24.7025 7.22516 25.4188 8.80516L25.4375 8.84641Z",
    fill: "url(#paint28_radial_1107_345)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 8.84641C26.9588 12.2002 28.825 16.3152 30.225 17.9502C30.5 17.3152 30.47 16.2502 30.7825 13.6502C31.065 11.3052 33 11.0814 33.8313 11.2477C35.6688 11.6314 36.2275 13.4927 36.1663 14.1789C36.0688 15.2727 36.0638 15.2352 35.8638 17.8814C35.57 21.7502 37.0638 24.6714 37.2013 27.9839C37.2013 34.2264 31.73 37.2939 27.9013 37.2939C24.8375 37.2939 21.7713 35.3339 20.6225 34.3539L14.8775 29.1064C14.1738 28.5602 12.4363 26.7552 11.6725 25.7164C9.59377 22.8877 12.6013 20.9389 14.2913 21.4289C14.1588 21.3264 13.3563 20.0239 12.9725 19.3864C11.9413 17.3152 12.9725 15.9364 13.735 15.5564C15.4638 14.6964 16.735 15.6639 17.135 16.1914C16.9813 15.9314 16.5013 14.8789 15.7275 12.9477C14.9538 11.0177 16.2 9.82516 16.92 9.47016C18.4825 8.74641 19.9675 9.66516 20.3388 10.4864C20.5213 10.8877 21.5013 13.0364 21.9288 13.9827C21.6063 13.1977 21.0238 11.6364 20.8175 10.9152C20.4075 9.21516 21.3938 8.05016 22.0188 7.75016C22.8888 7.33391 24.7025 7.22516 25.4188 8.80516L25.4375 8.84641Z",
    fill: "url(#paint29_radial_1107_345)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5575 13.335C28.4962 15.2525 29.4337 16.9712 30.2262 17.9125C30.3075 18.75 30.38 19.2275 30.58 19.95C28.9987 18.3675 27.4675 14.9087 27.5575 13.3337V13.335Z",
    fill: "url(#paint30_radial_1107_345)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15751 21.125C5.33632 21.1253 5.50769 21.1966 5.634 21.3231C5.76032 21.4497 5.83127 21.6212 5.83126 21.8C5.83126 22.925 6.28626 24.4313 7.26751 25.6475C8.23001 26.8438 9.69251 27.7487 11.7425 27.7487C11.9212 27.7487 12.0926 27.8197 12.2189 27.9461C12.3453 28.0724 12.4163 28.2438 12.4163 28.4225C12.4163 28.6012 12.3453 28.7726 12.2189 28.8989C12.0926 29.0253 11.9212 29.0963 11.7425 29.0963C9.24001 29.0963 7.40876 27.9713 6.21751 26.4938C5.04501 25.0388 4.48376 23.2325 4.48376 21.7987C4.4841 21.6202 4.55519 21.449 4.68147 21.3227C4.80775 21.1964 4.97893 21.1253 5.15751 21.125Z",
    fill: "url(#paint31_radial_1107_345)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15751 21.125C5.33632 21.1253 5.50769 21.1966 5.634 21.3231C5.76032 21.4497 5.83127 21.6212 5.83126 21.8C5.83126 22.925 6.28626 24.4313 7.26751 25.6475C8.23001 26.8438 9.69251 27.7487 11.7425 27.7487C11.9212 27.7487 12.0926 27.8197 12.2189 27.9461C12.3453 28.0724 12.4163 28.2438 12.4163 28.4225C12.4163 28.6012 12.3453 28.7726 12.2189 28.8989C12.0926 29.0253 11.9212 29.0963 11.7425 29.0963C9.24001 29.0963 7.40876 27.9713 6.21751 26.4938C5.04501 25.0388 4.48376 23.2325 4.48376 21.7987C4.4841 21.6202 4.55519 21.449 4.68147 21.3227C4.80775 21.1964 4.97893 21.1253 5.15751 21.125Z",
    fill: "url(#paint32_radial_1107_345)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15751 21.125C5.33632 21.1253 5.50769 21.1966 5.634 21.3231C5.76032 21.4497 5.83127 21.6212 5.83126 21.8C5.83126 22.925 6.28626 24.4313 7.26751 25.6475C8.23001 26.8438 9.69251 27.7487 11.7425 27.7487C11.9212 27.7487 12.0926 27.8197 12.2189 27.9461C12.3453 28.0724 12.4163 28.2438 12.4163 28.4225C12.4163 28.6012 12.3453 28.7726 12.2189 28.8989C12.0926 29.0253 11.9212 29.0963 11.7425 29.0963C9.24001 29.0963 7.40876 27.9713 6.21751 26.4938C5.04501 25.0388 4.48376 23.2325 4.48376 21.7987C4.4841 21.6202 4.55519 21.449 4.68147 21.3227C4.80775 21.1964 4.97893 21.1253 5.15751 21.125Z",
    fill: "url(#paint33_linear_1107_345)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05998 23.5288C3.239 23.5288 3.41069 23.5999 3.53728 23.7265C3.66386 23.8531 3.73498 24.0248 3.73498 24.2038C3.73498 26.5913 5.52248 29.7813 9.27998 29.7813C9.45867 29.7813 9.63004 29.8523 9.75639 29.9786C9.88275 30.105 9.95373 30.2764 9.95373 30.4551C9.95373 30.6337 9.88275 30.8051 9.75639 30.9315C9.63004 31.0578 9.45867 31.1288 9.27998 31.1288C4.55498 31.1288 2.38623 27.0913 2.38623 24.2038C2.38623 24.0248 2.45735 23.8531 2.58393 23.7265C2.71052 23.5999 2.88096 23.5288 3.05998 23.5288Z",
    fill: "url(#paint34_radial_1107_345)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05998 23.5288C3.239 23.5288 3.41069 23.5999 3.53728 23.7265C3.66386 23.8531 3.73498 24.0248 3.73498 24.2038C3.73498 26.5913 5.52248 29.7813 9.27998 29.7813C9.45867 29.7813 9.63004 29.8523 9.75639 29.9786C9.88275 30.105 9.95373 30.2764 9.95373 30.4551C9.95373 30.6337 9.88275 30.8051 9.75639 30.9315C9.63004 31.0578 9.45867 31.1288 9.27998 31.1288C4.55498 31.1288 2.38623 27.0913 2.38623 24.2038C2.38623 24.0248 2.45735 23.8531 2.58393 23.7265C2.71052 23.5999 2.88096 23.5288 3.05998 23.5288Z",
    fill: "url(#paint35_linear_1107_345)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.295 12.3152C28.2065 12.3156 28.1188 12.2987 28.0369 12.2653C27.9549 12.2319 27.8804 12.1827 27.8175 12.1205C27.7546 12.0583 27.7045 11.9843 27.6702 11.9027C27.6359 11.8211 27.618 11.7336 27.6175 11.6452C27.61 10.5202 27.145 9.01641 26.1562 7.80641C25.185 6.61641 23.7187 5.72141 21.6675 5.73391C21.4958 5.72462 21.3341 5.65015 21.2154 5.52571C21.0968 5.40127 21.0301 5.23622 21.0289 5.06427C21.0278 4.89232 21.0924 4.72643 21.2094 4.60045C21.3265 4.47448 21.4872 4.39792 21.6587 4.38641C24.1612 4.37016 26 5.48516 27.2 6.95391C28.3825 8.40141 28.955 10.2039 28.965 11.6364C28.9656 11.725 28.9488 11.8128 28.9155 11.8949C28.8822 11.977 28.833 12.0517 28.7707 12.1147C28.7085 12.1778 28.6345 12.2279 28.5528 12.2623C28.4712 12.2967 28.3836 12.3147 28.295 12.3152Z",
    fill: "url(#paint36_radial_1107_345)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.295 12.3152C28.2065 12.3156 28.1188 12.2987 28.0369 12.2653C27.9549 12.2319 27.8804 12.1827 27.8175 12.1205C27.7546 12.0583 27.7045 11.9843 27.6702 11.9027C27.6359 11.8211 27.618 11.7336 27.6175 11.6452C27.61 10.5202 27.145 9.01641 26.1562 7.80641C25.185 6.61641 23.7187 5.72141 21.6675 5.73391C21.4958 5.72462 21.3341 5.65015 21.2154 5.52571C21.0968 5.40127 21.0301 5.23622 21.0289 5.06427C21.0278 4.89232 21.0924 4.72643 21.2094 4.60045C21.3265 4.47448 21.4872 4.39792 21.6587 4.38641C24.1612 4.37016 26 5.48516 27.2 6.95391C28.3825 8.40141 28.955 10.2039 28.965 11.6364C28.9656 11.725 28.9488 11.8128 28.9155 11.8949C28.8822 11.977 28.833 12.0517 28.7707 12.1147C28.7085 12.1778 28.6345 12.2279 28.5528 12.2623C28.4712 12.2967 28.3836 12.3147 28.295 12.3152Z",
    fill: "url(#paint37_linear_1107_345)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.375 9.8988C30.2865 9.8993 30.1988 9.88236 30.1169 9.84896C30.035 9.81555 29.9604 9.76634 29.8975 9.70412C29.8346 9.64191 29.7846 9.56791 29.7502 9.48635C29.7159 9.4048 29.698 9.31728 29.6975 9.2288C29.6813 6.8413 27.8725 3.6613 24.115 3.6863C23.9363 3.68746 23.7645 3.61759 23.6373 3.49206C23.5102 3.36653 23.4381 3.19562 23.4369 3.01693C23.4357 2.83824 23.5056 2.66641 23.6311 2.53923C23.7567 2.41206 23.9276 2.33996 24.1063 2.3388C28.8313 2.30755 31.025 6.33255 31.0438 9.22005C31.0444 9.30853 31.0277 9.39627 30.9944 9.47827C30.9612 9.56027 30.9121 9.63491 30.85 9.69794C30.7879 9.76097 30.714 9.81114 30.6325 9.84561C30.551 9.88007 30.4635 9.89815 30.375 9.8988Z",
    fill: "url(#paint38_radial_1107_345)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.375 9.8988C30.2865 9.8993 30.1988 9.88236 30.1169 9.84896C30.035 9.81555 29.9604 9.76634 29.8975 9.70412C29.8346 9.64191 29.7846 9.56791 29.7502 9.48635C29.7159 9.4048 29.698 9.31728 29.6975 9.2288C29.6813 6.8413 27.8725 3.6613 24.115 3.6863C23.9363 3.68746 23.7645 3.61759 23.6373 3.49206C23.5102 3.36653 23.4381 3.19562 23.4369 3.01693C23.4357 2.83824 23.5056 2.66641 23.6311 2.53923C23.7567 2.41206 23.9276 2.33996 24.1063 2.3388C28.8313 2.30755 31.025 6.33255 31.0438 9.22005C31.0444 9.30853 31.0277 9.39627 30.9944 9.47827C30.9612 9.56027 30.9121 9.63491 30.85 9.69794C30.7879 9.76097 30.714 9.81114 30.6325 9.84561C30.551 9.88007 30.4635 9.89815 30.375 9.8988Z",
    fill: "url(#paint39_linear_1107_345)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1107_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1637 18.0364C25.7424 19.0126 20.2637 22.2201 18.6537 29.3664",
    stroke: "#FFC339",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1107_345",
    x: 15.6534,
    y: 15.0361,
    width: 15.5105,
    height: 17.3306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1107_345"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0837 17.2939) rotate(60.1006) scale(26.315 17.1912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFC133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#FFC53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#FFAD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#EC7D58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.2013 23.0752) rotate(-93.012) scale(15.6126 5.98114)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFE849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE647",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3264 11.9026) rotate(99.682) scale(8.36129 3.20319)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFE849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE647",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.2249 16.9374) scale(3.38184 13.7146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE9F2C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7099 22.2549) rotate(-94.0856) scale(5.69214 3.95364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC93D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC33A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.53 13.6139) rotate(151.024) scale(5.98335 12.0194)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1107_345",
    x1: 25.4738,
    y1: 19.7439,
    x2: 25.4738,
    y2: 16.5127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC337",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.28 8.85641) rotate(-13.4957) scale(4.01718 8.88346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7213 7.48391) rotate(33.3063) scale(3.92181 3.04061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99F2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1107_345",
    x1: 21.3425,
    y1: 15.3802,
    x2: 23.295,
    y2: 14.4427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A85300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#A85300",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.8912 15.4626) rotate(149.148) scale(5.76768 12.036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1107_345",
    x1: 19.9999,
    y1: 21.7189,
    x2: 19.9999,
    y2: 18.4214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC337",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2262 11.7864) rotate(-33.8929) scale(3.82768 11.6534)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3112 16.5126) rotate(-24.9048) scale(4.82355 22.0249)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9362 9.20762) rotate(32.6006) scale(3.98764 3.17821)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99F2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1107_345",
    x1: 16.6937,
    y1: 17.2939,
    x2: 17.9937,
    y2: 16.3851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A85300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#A85300",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5438 20.4626) rotate(137.351) scale(4.77821 9.35668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1107_345",
    x1: 16.8025,
    y1: 25.7113,
    x2: 16.8025,
    y2: 22.9451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC337",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3725 16.3626) rotate(-12.2959) scale(3.63918 7.70879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.15 21.3438) rotate(-40.217) scale(5.062 25.8786)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 15.2138) rotate(29.5035) scale(3.66081 2.75523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99F2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.92 22.4113) rotate(-45.7639) scale(2.07179 9.35435)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A85300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#A85300",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4813 25.8975) rotate(143.369) scale(4.69754 8.83866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2238 22.3463) rotate(-9.97762) scale(3.87257 6.7276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8391 26.6599) rotate(-34.314) scale(5.01979 24.2351)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3875 21.3538) rotate(24.5479) scale(3.75713 2.49315)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99F2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1107_345",
    x1: 18.6863,
    y1: 34.4813,
    x2: 15.54,
    y2: 28.0463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC337",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9363 15.6539) rotate(129.014) scale(21.7184 35.1233)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#F6814F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7814F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.405 15.8877) rotate(76.293) scale(23.0791 25.3229)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#F6814F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7814F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.6388 10.0289) rotate(64.44) scale(3.98361 3.55133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99F2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5812 17.6445) rotate(149.254) scale(1.517 4.69418)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#B4813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4813D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.11626 21.4875) rotate(62.071) scale(6.64021 9.84773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#419FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B6DCB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.23751 21.9813) rotate(2.38594) scale(0.938313 1.97469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5486C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5486C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1107_345",
    x1: 12.4163,
    y1: 25.7369,
    x2: 4.48376,
    y2: 25.7369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509079,
    stopColor: "#FF6069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B16CEA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.60246 24.9494) rotate(94.712) scale(5.25212 8.83094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#419FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B6DCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1107_345",
    x1: 9.95373,
    y1: 27.926,
    x2: 2.38623,
    y2: 27.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509079,
    stopColor: "#FF6069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B16CEA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.135 2.93266) rotate(60.196) scale(5.57899 8.27389)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#419FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B6DCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1107_345",
    x1: 28.965,
    y1: 8.97369,
    x2: 21.0289,
    y2: 8.97369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509079,
    stopColor: "#FF6069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B16CEA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_1107_345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4838 0.952554) rotate(60.69) scale(6.93077 10.2813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#419FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B6DCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1107_345",
    x1: 31.0438,
    y1: 6.71273,
    x2: 23.4369,
    y2: 6.71273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509079,
    stopColor: "#FF6069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B16CEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.400215a3649b23a39120d0e22874ae3a.svg";
export { ForwardRef as ReactComponent };